import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHomePageViewGAEvent } from 'app/hooks/use-home-page-view-ga-event';
import { checkCookieSearchData, init } from '../actions/baseActions';
import Flights from '../app/components/Flights/Flights';

const Home: NextPage = (props) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	// home_page_view fires per home/landing-page mount (here '/'; also the Sanity [slug]
	// landing pages), replacing the old fire-on-every-route emit in _app.tsx. SF-29: the
	// hook defers the emit until the User-ID is ready so the event carries user_id.
	useHomePageViewGAEvent();

	useEffect(() => {
		init('flights')(dispatch);
		checkCookieSearchData()(dispatch);
	}, []);

	return (
		<div>
			<NextSeo
				title={t('metadata.flights.title')}
				description={t('metadata.flights.description')}
				canonical={process.env.NEXT_PUBLIC_SITE_URL}
				openGraph={{
					url: `${process.env.NEXT_PUBLIC_SITE_URL}`,
					title: t('metadata.flights.title'),
					description: t('metadata.flights.description'),
					site_name: process.env.NEXT_PUBLIC_SITE_NAME,
				}}
			/>
			<Flights
				query={
					// @ts-ignore
					props.query
				}
			/>
		</div>
	);
};
Home.getInitialProps = async (ctx) => {
	const query = ctx.query;
	return { query };
};
export default Home;
